import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "keepExpandedInTab", "forwardRef", "shouldFillContainer"];
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { useCallback, useEffect, useRef } from 'react';
import { SearchAnchor, EnlargedSearchAnchor, KeyboardHighlightProvider } from '@atlassian/search-dialog';
import { useDialogExpansionContext } from '../dialog-expansion-context';
import { mergeRefCallback } from '../../utils/merge-ref-callback';
import { useFeaturesContext } from '../features-context/features-context';
export var KeyboardWrapperStateless = /*#__PURE__*/function (_React$Component) {
  _inherits(KeyboardWrapperStateless, _React$Component);
  var _super = _createSuper(KeyboardWrapperStateless);
  function KeyboardWrapperStateless() {
    var _this;
    _classCallCheck(this, KeyboardWrapperStateless);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      ref: null
    });
    /**
     * Hold a timeout id for the onBlur and onFocus handlers
     */
    _defineProperty(_assertThisInitialized(_this), "timeout", undefined);
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (event.key === 'Escape' && !event.defaultPrevented && _this.props.isExpanded) {
        event.preventDefault();
        _this.close();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onBlurHandler", function () {
      _this.timeout = window.setTimeout(function () {
        _this.close();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusHandler", function () {
      window.clearTimeout(_this.timeout);
    });
    _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
      if (_this.state.ref !== ref) {
        _this.setState({
          ref: ref
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var ref = _this.state.ref;
      ref && ref.blur();
      _this.props.onClose();
    });
    return _this;
  }
  _createClass(KeyboardWrapperStateless, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isExpanded = _this$props.isExpanded,
        isQuickFind = _this$props.isQuickFind,
        shouldFillContainer = _this$props.shouldFillContainer,
        children = _this$props.children;
      var SearchAnchorComponent = isQuickFind ? EnlargedSearchAnchor : SearchAnchor;
      return /*#__PURE__*/React.createElement(SearchAnchorComponent, {
        onBlur: this.onBlurHandler,
        onFocus: this.onFocusHandler,
        onKeyDown: this.handleKeyDown,
        isExpanded: isExpanded,
        shouldFillContainer: shouldFillContainer
      }, /*#__PURE__*/React.createElement(KeyboardHighlightProvider, {
        listenerNode: this.state.ref
      }, children ? children(this.setRef) : null));
    }
  }]);
  return KeyboardWrapperStateless;
}(React.Component);
export var KeyboardWrapper = function KeyboardWrapper(_ref) {
  var _useFeaturesContext$q;
  var children = _ref.children,
    _ref$keepExpandedInTa = _ref.keepExpandedInTab,
    keepExpandedInTab = _ref$keepExpandedInTa === void 0 ? false : _ref$keepExpandedInTa,
    forwardRef = _ref.forwardRef,
    shouldFillContainer = _ref.shouldFillContainer,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded,
    setIsExpanded = _useDialogExpansionCo.setIsExpanded,
    allowChangeExpand = _useDialogExpansionCo.allowChangeExpand;
  var inputRef = useRef(null);
  var mergedForwardref = mergeRefCallback(inputRef, forwardRef);
  var isQuickFind = (_useFeaturesContext$q = useFeaturesContext().quickFind) === null || _useFeaturesContext$q === void 0 ? void 0 : _useFeaturesContext$q.enabled;
  var onClose = useCallback(function () {
    setIsExpanded(false);
  }, [setIsExpanded]);
  var onTabChange = useCallback(function () {
    if (document.hidden) {
      allowChangeExpand(false);
    } else {
      if (isExpanded) {
        var _inputRef$current, _inputRef$current$foc;
        inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || (_inputRef$current$foc = _inputRef$current.focus) === null || _inputRef$current$foc === void 0 || _inputRef$current$foc.call(_inputRef$current);
      }
      allowChangeExpand(true);
    }
  }, [allowChangeExpand, isExpanded]);
  useEffect(function () {
    if (keepExpandedInTab) {
      document.addEventListener('visibilitychange', onTabChange);
      return function () {
        document.removeEventListener('visibilitychange', onTabChange);
      };
    }
  }, [onTabChange, keepExpandedInTab]);
  return /*#__PURE__*/React.createElement(KeyboardWrapperStateless, _extends({}, rest, {
    shouldFillContainer: shouldFillContainer,
    onClose: onClose,
    isExpanded: isExpanded,
    isQuickFind: isQuickFind
  }), function (setRef) {
    var ref = mergeRefCallback(setRef, mergedForwardref);
    var onRetry = function onRetry() {
      var _inputRef$current2, _inputRef$current2$fo;
      inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || (_inputRef$current2$fo = _inputRef$current2.focus) === null || _inputRef$current2$fo === void 0 || _inputRef$current2$fo.call(_inputRef$current2);
    };
    return children({
      ref: ref,
      onRetry: onRetry
    });
  });
};